module.exports = __webpack_public_path__ + "static/img/game-pic2.239f3d35.png";